module.exports = __webpack_public_path__ + "img/impressive_jewelry@2x.fac52a0.webp";